/**
 * Extract key_zip_url from vpn-login / Pritunl download_links response shapes.
 */
export function extractKeyZipUrl(downloadLinksData) {
  if (!downloadLinksData || typeof downloadLinksData !== 'object') return null;
  if (downloadLinksData.key_zip_url) return downloadLinksData.key_zip_url;
  if (Array.isArray(downloadLinksData) && downloadLinksData.length > 0 && downloadLinksData[0].key_zip_url) {
    return downloadLinksData[0].key_zip_url;
  }
  for (const key of Object.keys(downloadLinksData)) {
    if (key === 'key_zip_url') return downloadLinksData[key];
    const val = downloadLinksData[key];
    if (val && typeof val === 'object' && val.key_zip_url) return val.key_zip_url;
  }
  return null;
}

export function resolveVpnProfileDownloadUrl(keyZipUrl) {
  if (!keyZipUrl) return null;
  if (keyZipUrl.startsWith('http://') || keyZipUrl.startsWith('https://')) return keyZipUrl;
  const path = keyZipUrl.startsWith('/') ? keyZipUrl : `/${keyZipUrl}`;
  return `https://nodes.vpnnext.com${path}`;
}
